import AuthService from '../../services/AuthService'
import OrganizationService from '../../services/OrganizationService'
import UsersService from '../../services/UsersService'
import AdminService from '../../services/AdminService'
import router from '../../router'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'

export const namespaced = true

const initialState = {
  user: null,
  users: []
}

export const state = {
  user: null,
  users: [],
  projectUserMedia: [],
  userRole: {},
  userRoles: [],
  allUserRoles: []
}

export const mutations = {
  SET_USERS(state, data) {
    state.users = data
  },
  SET_AUTHENTICATED_USER(state, data) {
    state.user = data
    // router.push('/').catch(err => {})
  },
  SET_PROJECT_USER_MEDIA(state, data) {
    state.projectUserMedia = data
  },
  SET_USER_ROLE(state, data) {
    state.userRole = data
  },
  SET_USER_ROLES(state, data) {
    state.userRoles = data
  },
  SET_ALL_USER_ROLES(state, data) {
    state.allUserRoles = data
  },
  RESET(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchUsers: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return AdminService.getAllUsers().then(
      r => {
        context.commit('SET_USERS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_USERS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setCurrentUser: async function(context, value) {
    context.commit('SET_AUTHENTICATED_USER', value)
    let userRole = await UsersService.getUserRole()

    context.commit('SET_USER_ROLE', userRole.data)
    try {
      let isAllowedToAccess = (await UsersService.isAllowedOnResource(
        'admin-panel-access',
        'allowed'
      )).data
      if (
        Object.prototype.hasOwnProperty.call(isAllowedToAccess, 'isAllowed') &&
        isAllowedToAccess.isAllowed !== true
      ) {
        throw new Error('User is not allowed to access Admin Panel')
      }
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    } catch (e) {
      context.commit('SET_USER_ROLE', null)
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      await context.dispatch('UserStore/logout')
      AxiosErrorHandler.handler(e, context, router)
    }
    // context.commit('SET_AUTHENTICATED_USER', value)
    // UsersService.getUserRole().then(
    //   r => {
    //     context.commit('SET_USER_ROLE', r.data)
    //     context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    //   },
    //   e => {
    //     context.commit('SET_USER_ROLE', null)
    //     context.commit('SET_LOADING_STATUS', 'idle', { root: true })
    //     AxiosErrorHandler.handler(e, context, router)
    //   }
    // )
  },
  updateUserData: async function(context, value) {
    return UsersService.updateUserData(value)
      .then(res => {
        context.commit('SET_AUTHENTICATED_USER', res.data)
        context.dispatch(
          'NotificationStore/add',
          { type: 'info', message: 'Changes successfully saved' },
          { root: true }
        )
        return UsersService.getUserProfile()
      })
      .then(resp => {
        context.dispatch('UserStore/setCurrentUser', resp.data, { root: true })
      })
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  logout: async function(context) {
    await UsersService.logout()
    context.commit('RESET')
    await router.push('/')
  },
  updateUserPassword: function(context, value) {
    if (!value) {
      AxiosErrorHandler.handler(
        {
          message: 'Submitted data is incomplete.'
        },
        context,
        router
      )
    } else {
      UsersService.updateUserPassword(value)
        .then(res => {
          context.dispatch(
            'NotificationStore/add',
            { type: 'info', message: 'Password successfully updated' },
            { root: true }
          )
        })
        .catch(e => {
          AxiosErrorHandler.handler(e, context, router)
        })
    }
  },
  getProjectUserMedia: function(context, projectId) {
    UsersService.getProjectUserMedia(projectId).then(
      r => {
        context.commit('SET_PROJECT_USER_MEDIA', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_PROJECT_USER_MEDIA', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  getUserRole: function(context) {
    UsersService.getUserRole().then(
      r => {
        context.commit('SET_USER_ROLE', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_USER_ROLE', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  getUserRoles: function(context) {
    UsersService.getUserRoles().then(
      r => {
        context.commit('SET_USER_ROLES', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_USER_ROLES', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  getAllUserRoles: function(context) {
    UsersService.getAllUserRoles().then(
      r => {
        context.commit('SET_ALL_USER_ROLES', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_ALL_USER_ROLES', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  createUser: async function(context, value) {
    let res
    if (value.projectId) {

      const orgs = (await OrganizationService.getOrganizations())
      let domainForUserToBeInvited = 'app.sooada.com'
      outerLoop:
      for ( const org of orgs.data){
        const orgProjects = await OrganizationService.getProjectsForOrganization(org.id)
        console.log('Got OrgProjects')
        for (const orgProj of orgProjects.data){
          if ( orgProj.id === value.projectId && org.domain !== 'app.sooada.com' && org.domain !== 'localhost:3000') {
            domainForUserToBeInvited = org.domain
            break outerLoop
          }
        }
      }
      value.userData.domain = 'https://' + domainForUserToBeInvited

      res = await AdminService.createUserWithRoleForProject(
        value.userData,
        value.projectId
      ).catch(e => {
        AxiosErrorHandler.handler(e, context, router)
        throw new Error(e)
      })
    } else {
      res = await AdminService.createUserWithRole(value.userData)
    }
    return res
  },
  removeUserFromProject: async function(context, data) {
    await UsersService.removeUserFromProject(data).catch(e => {
      AxiosErrorHandler.handler(e, context, router)
      throw new Error(e)
    })
  },
  removeAdminFromProject: async function(context, data) {
    await UsersService.removeUserFromProject(data).catch(e => {
      AxiosErrorHandler.handler(e, context, router)
      console.error(e)
    })
  },
  changeAdmin: async function(context, value) {
    await UsersService.changeAdminOnProject(value).catch(e => {
      AxiosErrorHandler.handler(e, context, router)
      throw new Error(e)
    })
  },
  updateUser: async function(context, value) {
    let res
    res = await AdminService.updateUserWithUserRole(value)
    return res
  },
  logoutNoRedirect: async function(context) {
    await UsersService.logout()
    context.commit('RESET')
  },
  deleteUser: async function(context, value) {
    let res
    res = await AdminService.deleteUser(value)
    return res
  },
  isAllowed: async function(context, value) {
    let res
    if (value.projectId) {
      res = await UsersService.isAllowedOnResource(
        value.resourceName,
        value.permission,
        value.projectId
      )
    } else {
      res = await UsersService.isAllowedOnResource(
        value.resourceName,
        value.permission
      )
    }

    return res.data.isAllowed
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  userFullName: state => {
    let retVal = null
    if (state.user) {
      retVal = state.user.firstName + ' ' + state.user.lastName
    }
    return retVal
  },
  userLoggedIn: state => {
    return state.user //in component template you can: <div>{{$store.getters.userLoggedIn.firstName+' '+$store.getters.userLoggedIn.lastName}}</div>
  },
  userRole: state => {
    return state.userRole[0]
  }
}
